<template>
    <div>
        <div class="wrap">
            <div style="display: flex">
                <div style="flex: 2;text-align: left;padding: 40px 0 20px 0">
                    <div class="title">涉税风险管理-通用版</div>
                    <div class="content">为企业提供<span style="color: #ff9f18;font-size: 24px;font-face: PingFangSC;font-weight: 500;">可识别、可防控、可追溯、可解决</span>的税务风险解决服务
                    </div>
                    <div style="display: flex;margin-top: 30px">
                        <div style="display: flex;align-items: center;width: 200px">
                            <img width="24px" height="24px" src="../../assets/images/home/fxjc/swsjzx.png"/>
                            <div class="nrxq">税务数据中心</div>
                        </div>
                        <div style="display: flex;align-items: center">
                            <img width="24px" height="24px" src="../../assets/images/home/fxjc/gzlfxglmx.png"/>
                            <div class="nrxq">高质量风险模型</div>
                        </div>
                    </div>
                    <div style="display: flex;align-items: center;margin-top: 30px">
                        <img width="24px" height="24px" src="../../assets/images/home/fxjc/qfmfxty.png"/>
                        <div class="nrxq">全方面风险体检</div>
                    </div>
                </div>
                <div style="flex: 1">
                    <img width="100%" src="../../assets/images/home/fxjc/slt1.png"/>
                </div>
            </div>
            <div style="display: flex;margin-top: 20px">
                <div style="flex: 1">
                    <img width="100%" src="../../assets/images/home/fxjc/slt2.png"/>
                </div>
                <div style="flex: 2;text-align: left;padding: 0 0 20px 50px;">
                    <div class="title" style="margin-top: 10px">涉税风险管理-专项版</div>
                    <div class="content">为企业提供<span style="color: #ff9f18;font-size: 24px;font-face: PingFangSC;font-weight: 500;">不同行业、多端领域、专项业务</span>的专属税务风险服务
                    </div>
                    <div style="display: flex;margin-top: 20px">
                        <div style="display: flex;align-items: center;width: 200px">
                            <img width="24px" height="24px" src="../../assets/images/home/fxjc/dwfxfxbg.png"/>
                            <div class="nrxq">多维风险分析报告</div>
                        </div>
                        <div style="display: flex;align-items: center">
                            <img width="24px" height="24px" src="../../assets/images/home/fxjc/fxpg.png"/>
                            <div class="nrxq">风险全方位评估</div>
                        </div>
                    </div>
                    <div style="display: flex;margin-top: 20px">
                        <div style="display: flex;align-items: center;width: 200px">
                            <img width="24px" height="24px" src="../../assets/images/home/fxjc/fxgl.png"/>
                            <div class="nrxq">风险事项管理</div>
                        </div>
                        <div style="display: flex;align-items: center">
                            <img width="24px" height="24px" src="../../assets/images/home/fxjc/zbfa.png"/>
                            <div class="nrxq">灵活定制风险预警方案</div>
                        </div>
                    </div>
                </div>

            </div>

        </div>
        <div class="footBtns">
            <Button style="width: 170px;background-color: white;color: #2A6CFD;border-color: #2A6CFD" shape="circle"
                     size="large" @click="bgyl">报告样例
            </Button>
            <Button style="width: 170px;background-color: #2A6CFD;margin-left: 40px" shape="circle" type="primary"
                    size="large" @click="ljjc">立即检测
            </Button>
        </div>
    </div>

</template>
<script>
    // import eventBus from "../common/event_bus.js"
    export default {
        name: 'fxjc',
        data() {
            return {}
        },
        components: {},
        mounted() {
        },

        methods: {
            ljjc() {
                console.log('立即检测');
                this.$emit('risk-detection')
                //this.$router.push({ name: 'riskdetection' })
                // console.log("emit user-login")
                // setTimeout(()=>{
                //     eventBus.$emit("user-login", "true", '0')
                // },100)
            },
            bgyl() {
                console.log('报告样例');
                this.$router.push("/bgyl");
                // window.open('/bgyl');
            },
        },
    }
</script>
<style lang="less" scoped>
    .title {
        font-family: PingFangSC-Medium;
        font-weight: 500;
        font-size: 36px;
        color: #000000;
    }

    .content {
        margin-top: 10px;
        color: #333333;
        font-size: 24px;
        font-face: PingFangSC;
        font-weight: 400;
    }

    .wrap {
        display: flex;
        width: 100%;
        height: 82vh;
        padding: 0px 160px;
        flex: 1;
        overflow-y: auto;
        background-color: #F9F9F9;
        flex-direction: column;
    }

    .nrxq {
        margin-left: 10px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        font-size: 18px;
        color: #333333;
    }

    .footBtns {
        position: fixed;
        bottom: 0;
        z-index: 999;
        display: flex;
        width: 100%;
        height: 68px;
        padding: 0;
        background-color: white;
        justify-content: center;
        align-items: center;

    }
</style>
